// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__+jfuA","spinner":"Loader_spinner__vAUbw","spin":"Loader_spin__RLFM0"};